import { useEffect, useState } from "react";

export const useSize = () => {
  const [ref, setRef] = useState<Element | null>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (ref?.parentElement) {
      const observer = new ResizeObserver((entries) => {
        if (entries.length) {
          setSize({ width: entries[0].contentRect.width, height: entries[0].contentRect.height });
        }
      });
      observer.observe(ref.parentElement);
      return () => {
        observer.disconnect();
      };
    }
  }, [ref]);

  return { setRef, size };
};
